import { Component, NO_ERRORS_SCHEMA, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { DepositSearchResult } from '../../../models/depositSearchResult.model';
import { AuthorizationService } from '../../../services/authorization.service';
import { RemittanceEntryService } from '../../../services/remittance-entry/remittance-entry.service';

//  This is a Container component

@Component({
  selector: 'app-check-detail',
  templateUrl: './check-detail.component.html',
  styleUrls: ['./check-detail.component.css'],
})
export class CheckDetailComponent implements OnInit, OnDestroy {

  //  Subscriptions
  onCheckDetail: Subscription;

  //  Members
  private _checkDetail: DepositSearchResult

  get checkDetail(): DepositSearchResult {
    return this._checkDetail;
  }

  constructor(
    private authorizationService: AuthorizationService,
    private remittanceEntryService: RemittanceEntryService) {
      //  Subscribe to the Check Detail notification. This normally occurs
      //  when the user navigates to the Remittance Entry page from the Deposit
      //  Search page.
    this.onCheckDetail = remittanceEntryService.checkDetailSource$.subscribe(
      (check) => {
        this._checkDetail = check;
      },
      (error: any) => {
        console.log(`Error occurred at ${new Date()} status: ${error.status.toString()}`)
      },
      () => { },   //  Complete
    );
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    //  Cleanup subscription.
    this.onCheckDetail.unsubscribe()
  }
}



// WEBPACK FOOTER //
// ./src/app/components/remittance-entry/check-detail/check-detail.component.ts